var _path, _rect, _polygon, _polygon2, _polygon3, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.33,62c.59-4.24-5.4-7.73-9.89-8.09-2.15-.18-4.38.15-6.41-.56-4.4-1.53-6.16-7.22-10.45-9-3.21-1.36-6.91-.15-10,1.42s-6.19,3.54-9.67,3.76c-3,.19-6.31-.93-9,.55-2,1.1-3,3.37-4.82,4.71s-4.1,1.59-6.31,1.71-4.49.14-6.5,1.06-3.67,3-3.25,5.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.12,
    y: 137.51,
    width: 84.52,
    height: 267.86,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.38,
    y: 137.51,
    width: 42.26,
    height: 267.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.77,
    y: 111.22,
    width: 29.85,
    height: 26.3,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.5,
    y: 111.22,
    width: 7.11,
    height: 26.3,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "96.08 137.51 96.08 135.98 190.11 135.98 190.11 137.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 148.98,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,170c0,.15-9.46.28-21.13.28s-21.13-.13-21.13-.28,9.46-.29,21.13-.29S145.38,169.83,145.38,170Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.43,
    y: 148.98,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,170c0,.15-9.46.28-21.13.28s-21.13-.13-21.13-.28,9.46-.29,21.13-.29S188,169.83,188,170Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.43,
    y: 178.93,
    width: 7.15,
    height: 15.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,199.94c0,.15-9.46.28-21.13.28s-21.13-.13-21.13-.28,9.46-.29,21.13-.29S188,199.78,188,199.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.43,
    y: 209.78,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,230.79c0,.16-9.46.29-21.13.29s-21.13-.13-21.13-.29,9.46-.29,21.13-.29S188,230.63,188,230.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.43,
    y: 240.64,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,261.64c0,.16-9.46.29-21.13.29s-21.13-.13-21.13-.29,9.46-.29,21.13-.29S188,261.48,188,261.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.43,
    y: 270.61,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,291.61c0,.16-9.46.29-21.13.29s-21.13-.13-21.13-.29,9.46-.29,21.13-.29S188,291.45,188,291.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.43,
    y: 300.7,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.43,
    y: 331.18,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,321.7c0,.16-9.46.29-21.13.29s-21.13-.13-21.13-.29,9.46-.28,21.13-.28S188,321.55,188,321.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 179.39,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,200.39c0,.16-9.46.29-21.13.29s-21.13-.13-21.13-.29,9.46-.29,21.13-.29S145.38,200.23,145.38,200.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 209.79,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,230.8c0,.16-9.46.29-21.13.29s-21.13-.13-21.13-.29,9.46-.29,21.13-.29S145.38,230.64,145.38,230.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 240.2,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,261.21c0,.15-9.46.28-21.13.28s-21.13-.13-21.13-.28,9.46-.29,21.13-.29S145.38,261.05,145.38,261.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 270.61,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,291.61c0,.16-9.46.29-21.13.29s-21.13-.13-21.13-.29,9.46-.29,21.13-.29S145.38,291.45,145.38,291.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 301.01,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,322c0,.16-9.46.29-21.13.29s-21.13-.13-21.13-.29,9.46-.29,21.13-.29S145.38,321.86,145.38,322Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 331.42,
    width: 7.15,
    height: 15.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.31,
    y: 76.42,
    width: 121.83,
    height: 386.1,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.22,
    y: 76.42,
    width: 60.91,
    height: 385.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.22,
    y: 38.52,
    width: 43.02,
    height: 37.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.99,
    y: 38.52,
    width: 10.25,
    height: 37.91,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "389.16 76.42 389.16 74.21 524.7 74.21 524.7 76.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.36,
    y: 92.96,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.22,123.23c0,.23-13.63.42-30.45.42s-30.46-.19-30.46-.42,13.63-.41,30.46-.41S460.22,123,460.22,123.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.8,
    y: 92.96,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.67,123.23c0,.23-13.64.42-30.46.42s-30.46-.19-30.46-.42,13.64-.41,30.46-.41S521.67,123,521.67,123.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.8,
    y: 136.13,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.67,166.41c0,.23-13.64.41-30.46.41s-30.46-.18-30.46-.41,13.64-.42,30.46-.42S521.67,166.18,521.67,166.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.8,
    y: 180.6,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.67,210.88c0,.23-13.64.42-30.46.42s-30.46-.19-30.46-.42,13.64-.42,30.46-.42S521.67,210.65,521.67,210.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.8,
    y: 225.08,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.67,255.35c0,.23-13.64.42-30.46.42s-30.46-.19-30.46-.42,13.64-.41,30.46-.41S521.67,255.12,521.67,255.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.8,
    y: 268.28,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.67,298.56c0,.22-13.64.41-30.46.41s-30.46-.19-30.46-.41,13.64-.42,30.46-.42S521.67,298.33,521.67,298.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.8,
    y: 311.65,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.8,
    y: 355.6,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.67,341.93c0,.23-13.64.42-30.46.42s-30.46-.19-30.46-.42,13.64-.41,30.46-.41S521.67,341.7,521.67,341.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.36,
    y: 136.79,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.22,167.07c0,.22-13.63.41-30.45.41s-30.46-.19-30.46-.41,13.63-.42,30.46-.42S460.22,166.84,460.22,167.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.36,
    y: 180.62,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.22,210.9c0,.22-13.63.41-30.45.41s-30.46-.19-30.46-.41,13.63-.42,30.46-.42S460.22,210.67,460.22,210.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.36,
    y: 224.45,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.22,254.73c0,.22-13.63.41-30.45.41s-30.46-.19-30.46-.41,13.63-.42,30.46-.42S460.22,254.5,460.22,254.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.36,
    y: 268.28,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.22,298.56c0,.22-13.63.41-30.45.41s-30.46-.19-30.46-.41,13.63-.42,30.46-.42S460.22,298.33,460.22,298.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.36,
    y: 312.11,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.22,342.39c0,.23-13.63.41-30.45.41s-30.46-.18-30.46-.41,13.63-.42,30.46-.42S460.22,342.16,460.22,342.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.36,
    y: 355.94,
    width: 10.31,
    height: 21.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.57,
    y: 251.57,
    width: 66.56,
    height: 210.94,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.85,
    y: 251.57,
    width: 33.28,
    height: 210.36,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.17,
    y: 230.86,
    width: 23.5,
    height: 20.71,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.07,
    y: 230.86,
    width: 5.6,
    height: 20.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "492.02 251.57 492.02 250.36 566.08 250.36 566.08 251.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.71,
    y: 260.6,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.85,277.15c0,.12-7.45.22-16.64.22s-16.64-.1-16.64-.22,7.45-.23,16.64-.23S530.85,277,530.85,277.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.28,
    y: 260.6,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.42,277.15c0,.12-7.45.22-16.64.22s-16.64-.1-16.64-.22,7.45-.23,16.64-.23S564.42,277,564.42,277.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.28,
    y: 284.19,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.42,300.73c0,.13-7.45.23-16.64.23s-16.64-.1-16.64-.23,7.45-.23,16.64-.23S564.42,300.61,564.42,300.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.28,
    y: 308.49,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.42,325c0,.12-7.45.23-16.64.23s-16.64-.11-16.64-.23,7.45-.23,16.64-.23S564.42,324.9,564.42,325Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.28,
    y: 332.78,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.42,349.33c0,.12-7.45.22-16.64.22s-16.64-.1-16.64-.22,7.45-.23,16.64-.23S564.42,349.2,564.42,349.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.28,
    y: 356.39,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.42,372.93c0,.13-7.45.23-16.64.23s-16.64-.1-16.64-.23,7.45-.23,16.64-.23S564.42,372.8,564.42,372.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.28,
    y: 380.09,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.28,
    y: 404.09,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.42,396.63c0,.12-7.45.22-16.64.22s-16.64-.1-16.64-.22,7.45-.23,16.64-.23S564.42,396.5,564.42,396.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.71,
    y: 284.55,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.85,301.09c0,.13-7.45.23-16.64.23s-16.64-.1-16.64-.23,7.45-.23,16.64-.23S530.85,301,530.85,301.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.71,
    y: 308.5,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.85,325c0,.12-7.45.22-16.64.22s-16.64-.1-16.64-.22,7.45-.23,16.64-.23S530.85,324.91,530.85,325Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.71,
    y: 332.44,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.85,349c0,.13-7.45.23-16.64.23s-16.64-.1-16.64-.23,7.45-.22,16.64-.22S530.85,348.86,530.85,349Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.71,
    y: 356.39,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.85,372.93c0,.13-7.45.23-16.64.23s-16.64-.1-16.64-.23,7.45-.23,16.64-.23S530.85,372.8,530.85,372.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.71,
    y: 380.33,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.85,396.88c0,.12-7.45.22-16.64.22s-16.64-.1-16.64-.22,7.45-.23,16.64-.23S530.85,396.75,530.85,396.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.71,
    y: 404.28,
    width: 5.63,
    height: 11.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.67,
    y: 326.52,
    width: 71.66,
    height: 136,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.73,
    y: 326.52,
    width: 33.6,
    height: 136,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.7,
    y: 339.31,
    width: 6.44,
    height: 15.65,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.7,
    y: 400.58,
    width: 6.44,
    height: 15.65,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.73,361.11c0,.14-8.52.24-19,.24s-19-.1-19-.24,8.52-.24,19-.24S196.73,361,196.73,361.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.7,
    y: 370.18,
    width: 6.44,
    height: 15.65,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.73,392c0,.13-8.52.24-19,.24s-19-.11-19-.24,8.52-.25,19-.25S196.73,391.84,196.73,392Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.87,
    y: 339.31,
    width: 6.44,
    height: 15.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.85,
    y: 339.31,
    width: 6.44,
    height: 15.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.87,
    y: 369.02,
    width: 6.44,
    height: 15.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.85,
    y: 369.02,
    width: 6.44,
    height: 15.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.87,
    y: 398.72,
    width: 6.44,
    height: 15.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.85,
    y: 398.72,
    width: 6.44,
    height: 15.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.29,
    y: 323.23,
    width: 82.43,
    height: 3.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.83,327c0,.13-16,.24-35.77.24s-35.77-.11-35.77-.24,16-.25,35.77-.25S230.83,326.82,230.83,327Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.49 462.42 44.09 462.42 43.58 280.03 158.99 280.03 159.49 462.42",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.29,
    y: 280.03,
    width: 57.7,
    height: 182.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.76,
    y: 244.12,
    width: 40.75,
    height: 35.91,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.8,
    y: 244.12,
    width: 9.71,
    height: 35.91,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.97,
    y: 277.93,
    width: 128.4,
    height: 2.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.36,
    y: 295.69,
    width: 9.77,
    height: 20.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.29,324.37c0,.22-12.92.39-28.85.39s-28.86-.17-28.86-.39S56.5,324,72.44,324,101.29,324.15,101.29,324.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.57,
    y: 295.69,
    width: 9.77,
    height: 20.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,324.37c0,.22-12.92.39-28.85.39s-28.85-.17-28.85-.39,12.91-.39,28.85-.39S159.49,324.15,159.49,324.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.57,
    y: 336.58,
    width: 9.77,
    height: 20.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,365.27c0,.21-12.92.39-28.85.39s-28.85-.18-28.85-.39,12.91-.4,28.85-.4S159.49,365.05,159.49,365.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.57,
    y: 378.71,
    width: 9.77,
    height: 20.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,407.4c0,.21-12.92.39-28.85.39s-28.85-.18-28.85-.39,12.91-.4,28.85-.4S159.49,407.18,159.49,407.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.57,
    y: 420.84,
    width: 9.77,
    height: 20.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,449.52c0,.22-12.92.4-28.85.4s-28.85-.18-28.85-.4,12.91-.39,28.85-.39S159.49,449.31,159.49,449.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.36,
    y: 337.21,
    width: 9.77,
    height: 20.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.29,365.89c0,.22-12.92.39-28.85.39s-28.86-.17-28.86-.39,12.92-.39,28.86-.39S101.29,365.67,101.29,365.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.36,
    y: 378.73,
    width: 9.77,
    height: 20.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.29,407.41c0,.22-12.92.39-28.85.39s-28.86-.17-28.86-.39S56.5,407,72.44,407,101.29,407.19,101.29,407.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.36,
    y: 420.25,
    width: 9.77,
    height: 20.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.29,448.93c0,.22-12.92.39-28.85.39s-28.86-.17-28.86-.39,12.92-.39,28.86-.39S101.29,448.71,101.29,448.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.55,180c.83-6.06-7.72-11-14.15-11.56-3.06-.25-6.25.22-9.15-.79-6.29-2.19-8.8-10.32-14.94-12.91-4.59-1.94-9.88-.21-14.32,2s-8.85,5.05-13.82,5.37c-4.32.28-9-1.33-12.8.79-2.82,1.57-4.3,4.82-6.9,6.74s-5.85,2.27-9,2.44-6.42.2-9.29,1.52-5.25,4.35-4.65,7.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.28,
    y: 395.77,
    width: 92.84,
    height: 66.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.18,395.77c.14,0,0,14.09,0,14.09h-6.87V395.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.7,
    y: 395.77,
    width: 46.42,
    height: 66.74,
    transform: "translate(1417.82 858.28) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.11,
    y: 449.45,
    width: 12.43,
    height: 8.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 656.84,
    y: 449.45,
    width: 6.21,
    height: 8.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662.85,
    y: 352.31,
    width: 60.45,
    height: 43.46,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.07,352.31c.08,0,0,9.18,0,9.18h-4.48v-9.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.08,
    y: 352.31,
    width: 30.22,
    height: 43.46,
    transform: "translate(1416.38 748.08) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.7,
    y: 387.26,
    width: 8.09,
    height: 5.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 674.28,
    y: 387.26,
    width: 4.05,
    height: 5.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.41,63.5c.47-3.43-4.37-6.26-8-6.55-1.74-.14-3.54.12-5.19-.45-3.56-1.24-5-5.84-8.46-7.31-2.6-1.1-5.59-.12-8.11,1.15s-5,2.86-7.82,3c-2.45.16-5.11-.75-7.25.45-1.6.89-2.44,2.73-3.91,3.81A9.34,9.34,0,0,1,51.56,59a14.08,14.08,0,0,0-5.26.86c-1.63.74-3,2.46-2.64,4.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.41,133.17c.46-3.35-4.26-6.1-7.81-6.39-1.69-.13-3.45.12-5.06-.43-3.47-1.22-4.86-5.71-8.25-7.14-2.53-1.06-5.45-.11-7.91,1.12s-4.89,2.8-7.63,3c-2.39.16-5-.73-7.07.44-1.56.87-2.37,2.66-3.81,3.72a9.18,9.18,0,0,1-5,1.35,13.86,13.86,0,0,0-5.13.84c-1.59.72-2.9,2.4-2.57,4.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.72,84.75c.86-6.27-8-11.43-14.63-12-3.18-.25-6.47.23-9.47-.81-6.51-2.27-9.11-10.68-15.46-13.36-4.75-2-10.21-.22-14.81,2.1s-9.15,5.23-14.29,5.56c-4.48.29-9.33-1.37-13.25.81-2.91,1.63-4.44,5-7.13,7s-6.05,2.35-9.32,2.53-6.64.21-9.61,1.57-5.42,4.5-4.81,7.71Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M731.78,462.51c0,.15-152.7.26-341,.26s-341-.11-341-.26,152.67-.26,341.05-.26S731.78,462.37,731.78,462.51Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.55,420.64a8.1,8.1,0,0,1,5.12,3.75,14.22,14.22,0,0,1,1.93,6.17c.44,4.19-1,8.83-2.76,12.64-4.1-2.25-6-7.31-6.87-9.94-1.3-4.16-1.13-12.47,2.58-12.62",
    style: {
      fill: "#807C7B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.32,449.07a6.94,6.94,0,0,1,.77-6.91,9.2,9.2,0,0,1,6.17-3.52,3.84,3.84,0,0,1,3.19.67,3,3,0,0,1,.69,2.92,6.08,6.08,0,0,1-1.7,2.61c-2.57,2.52-5.52,4.5-9.12,4.23",
    style: {
      fill: "#807C7B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.67,462.56a4.19,4.19,0,0,1-.07-.86c0-.62-.05-1.41-.08-2.36a24.33,24.33,0,0,1,.75-7.77,14.75,14.75,0,0,1,4-6.67,10.06,10.06,0,0,1,1.91-1.4,4.37,4.37,0,0,1,.58-.29c.13-.06.2-.09.21-.08a16,16,0,0,0-2.56,1.93,15.36,15.36,0,0,0-3.84,6.6,25.78,25.78,0,0,0-.82,7.68c0,1,0,1.8,0,2.36A4.46,4.46,0,0,1,330.67,462.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,427a1.63,1.63,0,0,1,.12.35c.08.27.17.62.29,1,.25.91.6,2.22,1,3.85.83,3.25,1.91,7.75,3,12.76s1.95,9.55,2.54,12.86c.29,1.65.52,3,.66,3.91.07.44.12.8.16,1.07a2.7,2.7,0,0,1,0,.38,1.59,1.59,0,0,1-.1-.37c-.06-.27-.13-.62-.22-1.06-.18-.95-.44-2.28-.75-3.89-.64-3.29-1.55-7.84-2.62-12.84s-2.13-9.51-2.9-12.77c-.38-1.61-.69-2.92-.91-3.87l-.24-1A1.71,1.71,0,0,1,323,427Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.92,452.86a16.2,16.2,0,0,0-11.18-9.68c-1.27-.3-2.85-.33-3.61.74s-.2,2.55.52,3.64a13.83,13.83,0,0,0,14.26,5.66",
    style: {
      fill: "#807C7B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.15,446.94a3.77,3.77,0,0,1,.8.15,9.11,9.11,0,0,1,.92.26c.36.13.77.23,1.2.43a13.86,13.86,0,0,1,1.4.64,15.26,15.26,0,0,1,1.53.88,17.78,17.78,0,0,1,3.12,2.59,17.51,17.51,0,0,1,2.4,3.27,15.32,15.32,0,0,1,.77,1.59,14.63,14.63,0,0,1,.54,1.44,11.91,11.91,0,0,1,.32,1.23,6.08,6.08,0,0,1,.18.94,4,4,0,0,1,.09.81c-.07,0-.2-1.15-.8-2.91a13.72,13.72,0,0,0-.56-1.41,14.19,14.19,0,0,0-.79-1.55,17.71,17.71,0,0,0-2.37-3.2,18.42,18.42,0,0,0-3-2.56,16.52,16.52,0,0,0-1.5-.9c-.47-.27-.94-.47-1.36-.66C318.27,447.24,317.13,447,317.15,446.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641,452c.38-1.46-.58-2.93-1.66-4s-2.37-2-2.93-3.42c-.91-2.28.31-5.23-1.24-7.13-.91-1.12-2.54-1.5-3.35-2.69a6.1,6.1,0,0,1-.73-2.14,21.69,21.69,0,0,0-5.4-10.09,18.92,18.92,0,0,0,2.12,9.73A12.33,12.33,0,0,1,629.4,436c.34,2.17-.87,4.4-.34,6.53.61,2.43,3.34,4.06,3.47,6.56.11,2.12-1.74,4-1.6,6.1a5.82,5.82,0,0,0,.94,2.51,8.42,8.42,0,0,0,7.69,4.53l4.47.16Z",
    style: {
      fill: "#807C7B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M641,452c.38-1.46-.58-2.93-1.66-4s-2.37-2-2.93-3.42c-.91-2.28.31-5.23-1.24-7.13-.91-1.12-2.54-1.5-3.35-2.69a6.1,6.1,0,0,1-.73-2.14,21.69,21.69,0,0,0-5.4-10.09,18.92,18.92,0,0,0,2.12,9.73A12.33,12.33,0,0,1,629.4,436c.34,2.17-.87,4.4-.34,6.53.61,2.43,3.34,4.06,3.47,6.56.11,2.12-1.74,4-1.6,6.1a5.82,5.82,0,0,0,.94,2.51,8.42,8.42,0,0,0,7.69,4.53l4.47.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M644.93,462.49a3.51,3.51,0,0,0,1.23,0,7.59,7.59,0,0,0,1.45-.36,6.2,6.2,0,0,0,1.79-1,2.47,2.47,0,0,0,.74-1,4.81,4.81,0,0,0,.21-1.33,12.1,12.1,0,0,1,.11-1.45,3.8,3.8,0,0,1,.54-1.43,10.8,10.8,0,0,0,1.68-3.06,10,10,0,0,0-.12-3.91,8.33,8.33,0,0,1,.11-4.2c.48-1.39,1.45-2.66,1.94-4.23s.26-3.3.37-5a6.56,6.56,0,0,1,.58-2.48c.36-.79.86-1.53,1.25-2.36a17,17,0,0,0,1.15-5.46c.11-.94.22-1.89.32-2.85a13.82,13.82,0,0,1,.5-2.86,22.76,22.76,0,0,1,1.07-2.76,10.79,10.79,0,0,0,.52-1.45c.08-.52.11-1,.14-1.53a17.76,17.76,0,0,0-.12-3.09c-.12-1-.31-2.06-.42-3.09l0-.18,0-.2-.18.09a6.87,6.87,0,0,0-2.41,2,10.87,10.87,0,0,0-1.47,2.72,32.66,32.66,0,0,0-1.39,5.85,16.06,16.06,0,0,1-1.84,5.4c-.49.79-1.08,1.52-1.6,2.29a6.33,6.33,0,0,0-1.11,2.55c-.26,1.89.78,3.55.56,5.22a5.65,5.65,0,0,1-.81,2.32c-.41.71-.88,1.37-1.34,2a12.5,12.5,0,0,0-1.19,2.06,6.35,6.35,0,0,0-.55,2.24c-.11,1.5.1,2.93,0,4.28a9.82,9.82,0,0,1-1.1,3.67c-.54,1.1-1.14,2.09-1.64,3a15.3,15.3,0,0,0-.68,1.43,6.92,6.92,0,0,0-.39,1.41,8.79,8.79,0,0,0,0,2.55,6.5,6.5,0,0,0,1.28,3.25,4.87,4.87,0,0,0,.36.39,2,2,0,0,0,.3.25l.25.18a6,6,0,0,1-.86-.86,6.4,6.4,0,0,1-1.22-3.23,8.92,8.92,0,0,1,.06-2.51,7.39,7.39,0,0,1,.4-1.38,14.89,14.89,0,0,1,.68-1.4c.5-1,1.11-1.94,1.66-3.05a10,10,0,0,0,1.14-3.73c.12-1.38-.09-2.82,0-4.29a6.19,6.19,0,0,1,.54-2.16,12.21,12.21,0,0,1,1.18-2c.45-.66.93-1.32,1.35-2.05a5.89,5.89,0,0,0,.85-2.41c.22-1.79-.81-3.46-.55-5.21a6.13,6.13,0,0,1,1.08-2.44c.5-.76,1.1-1.48,1.6-2.3a16,16,0,0,0,1.88-5.49,33.72,33.72,0,0,1,1.38-5.8,10.81,10.81,0,0,1,1.44-2.65,6.53,6.53,0,0,1,2.3-1.94l-.2-.12,0,.18c.11,1.05.3,2.07.42,3.09a18.26,18.26,0,0,1,.11,3,12,12,0,0,1-.13,1.49,9.37,9.37,0,0,1-.5,1.4,23,23,0,0,0-1.08,2.79,14,14,0,0,0-.5,2.9c-.11,1-.22,1.92-.32,2.86a16.85,16.85,0,0,1-1.12,5.37c-.37.81-.87,1.56-1.25,2.38a6.83,6.83,0,0,0-.59,2.57c-.1,1.72.12,3.41-.34,4.93s-1.44,2.79-1.93,4.23a8.5,8.5,0,0,0-.1,4.3,10.05,10.05,0,0,1,.15,3.84,10.86,10.86,0,0,1-1.65,3,4,4,0,0,0-.55,1.49,12.65,12.65,0,0,0-.1,1.46,4.49,4.49,0,0,1-.19,1.3,2.42,2.42,0,0,1-.69.94,6.14,6.14,0,0,1-1.75,1,7.5,7.5,0,0,1-1.43.38,4.41,4.41,0,0,1-.91.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,409.88a1,1,0,0,0,0,.14l-.1.4c-.09.35-.19.88-.36,1.55s-.58,1.4-.93,2.33a31.44,31.44,0,0,0-1.06,3.16c-.34,1.2-.64,2.52-1,3.93a16.31,16.31,0,0,1-1.43,4.37c-.36.72-.78,1.46-1.1,2.26a10.46,10.46,0,0,0-.65,2.56,51.12,51.12,0,0,1-1,5.4c-.89,3.66-1.75,7.15-2.52,10.32s-1.52,6-2.12,8.42-1.07,4.31-1.4,5.68c-.16.65-.28,1.17-.37,1.54l-.09.41a.72.72,0,0,0,0,.14s0-.05.05-.14l.12-.39c.1-.38.24-.89.42-1.54.35-1.36.86-3.28,1.49-5.65s1.35-5.25,2.17-8.4,1.65-6.66,2.55-10.32a52.58,52.58,0,0,0,1-5.43,10.77,10.77,0,0,1,.62-2.5c.32-.78.72-1.51,1.09-2.25a16.69,16.69,0,0,0,1.42-4.42c.31-1.42.6-2.74.92-3.93s.68-2.25,1-3.17.72-1.67.88-2.36.24-1.2.31-1.56L659,410C659,409.93,659,409.88,659,409.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.72,462.5c2.92-1.73,3.75-7,2.54-10.16s-3.35-6.06-3.68-9.44c-.25-2.6.6-5.26,0-7.8-.81-3.42-4.15-6.07-4.12-9.59,0-2,1.15-3.84,1.06-5.81-.11-2.42-2-4.34-3.12-6.47-1.76-3.27-1.87-7.12-2.48-10.78s-2-7.58-5.24-9.38c-.47,3.11-1.29,5.24-1,9.44.1,1.52,1.85,4.41,2.09,7.72.14,2,.24,4,.36,5.94a19.23,19.23,0,0,0,.94,5.7c.53,1.38,1.38,2.64,1.77,4.06.74,2.69-.23,5.6.37,8.32.5,2.3,2.1,4.28,2.42,6.62.46,3.28-1.66,6.69-.58,9.82.54,1.56,1.82,2.81,2.18,4.41.29,1.25,0,2.56.23,3.81.41,2,4.26,3.58,6.31,3.46",
    style: {
      fill: "#807C7B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.48,396.16s0,.06,0,.17l.07.51c.06.45.14,1.11.29,2s.6,1.82,1,3,.74,2.5,1.07,4,.61,3.15.9,4.93a20.36,20.36,0,0,0,1.5,5.58c.4.94.86,1.87,1.21,2.86a13,13,0,0,1,.61,3.16,64,64,0,0,0,.86,6.79c.89,4.6,1.74,9,2.52,13s1.55,7.55,2.17,10.57,1.13,5.42,1.49,7.12c.17.82.31,1.47.41,1.93l.12.5.05.17a1.06,1.06,0,0,0,0-.17l-.09-.51c-.09-.46-.21-1.12-.36-1.95-.34-1.7-.82-4.13-1.4-7.13S642.53,446,641.74,442s-1.61-8.37-2.5-13a66,66,0,0,1-.86-6.77,13.31,13.31,0,0,0-.63-3.22c-.36-1-.82-1.95-1.23-2.87a20.8,20.8,0,0,1-1.51-5.52c-.3-1.78-.59-3.44-.94-4.94a41.19,41.19,0,0,0-1.11-4c-.37-1.16-.83-2.12-1-3s-.26-1.51-.35-1.95c0-.21-.07-.37-.09-.5A.68.68,0,0,0,631.48,396.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Vehicle--inject-267"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.49,
    y: 330.53,
    width: 444.07,
    height: 44.38,
    style: {
      fill: "#807C7B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116.49,
    y: 330.53,
    width: 444.07,
    height: 44.38
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 333.27,
    y: 380.51,
    width: 131.08,
    height: 41.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.67 361.92 241.67 416.25 286.43 416.25 304.37 390.25 631.18 390.25 631.18 361.92 241.67 361.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.88,189.88a3.34,3.34,0,0,0-3.46-3.15c-17.69.73-101.67,4.58-118.94,12.88-13.22,6.36-27.7,30.1-37.91,46.09-7.32,11.46-23.49,36.9-26.76,49.91-2.77,11-4.44,33.88-4.25,45.23l4.62,60.06h76.11l7.62-19.84a33.5,33.5,0,0,1,31.27-21.47h75.63V259.92Z",
    style: {
      fill: "#807C7B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.46,206.26c-10.48,10-21,27-28.89,39.44-6.78,10.61-21.14,33.2-25.83,46.82-.09.25-.16.49-.24.74,2.32-.64,5.89-1.95,7-4.15,1.67-3.33,3.81-14.74,30.27-57.81C97.81,218.17,105.65,210.49,107.46,206.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.78,201.81c-19.46,1.11-61.65,4-75.13,8.58-17.56,6-37.27,52.49-38.2,54.53l-13.28,34a1.48,1.48,0,0,0,1.4,1.95H108.9a11,11,0,0,0,3.81-.68L203,266.53a10.44,10.44,0,0,0,6.79-9.78V211.28A9.48,9.48,0,0,0,199.78,201.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,297.53S89.72,269,94,259.65c6.46-14.12,21.55-43,31.74-46.11,9.37-2.81,36.31-6.23,74.23-8.4h.36a6.16,6.16,0,0,1,6.14,6.15v46.5a5.65,5.65,0,0,1-3.66,5.27l-66.71,8.23a18.57,18.57,0,0,0-13.25,8.24l-11.56,17.63a6.11,6.11,0,0,1-2.12.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.68,271.8,111,297.06l12.55-83.87,3.14-1.08-6.18,62.13a1.83,1.83,0,0,0,2.5,1.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.07,346.67c-.08-1.09.29-2,.85-2l12.16-1.12c1-.1,1.93,1.79,2.05,4l.55,9.33c.09,1.5-.36,2.77-1,2.88l-12.4,2.14c-.56.1-1.1-.73-1.18-1.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 390.26,
    width: 87.62,
    height: 35.13,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.35,
    cy: 414.17,
    r: 47.94,
    transform: "translate(-15.78 7.62) rotate(-2.2)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.43,413.35a.53.53,0,0,1,0,.13,47.94,47.94,0,0,0,95.87,1.38s0-.08,0-.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.7,413.68a33.66,33.66,0,1,0,34.14-33.16A33.66,33.66,0,0,0,156.7,413.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.84,380.52a33.66,33.66,0,0,0-34.14,33.16l67.31,1A33.67,33.67,0,0,0,190.84,380.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.86,413.87a20.5,20.5,0,1,0,20.79-20.2A20.5,20.5,0,0,0,169.86,413.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.48,
    y: 232.26,
    width: 19.87,
    height: 47.69,
    rx: 7.98,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.26,309.43h-1V259a9.08,9.08,0,0,1,9.07-9.07h2.4v1h-2.4A8.08,8.08,0,0,0,77.26,259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.07,309.49l-2.78-47.15a6,6,0,0,1,5.93-6.29v1a4.94,4.94,0,0,0-4.93,5.23l2.78,47.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.74,
    y: 304.89,
    width: 13.48,
    height: 15.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.76,
    y: 275.26,
    width: 5.48,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,203.16l1.19-.16,3.51-.41,13.6-1.57L197,195.25c2.7-.29,5.45-.65,8.3-.9a15.58,15.58,0,0,1,4.35.28,16.88,16.88,0,0,1,4.17,1.58,15.55,15.55,0,0,1,6.31,6.56,14.62,14.62,0,0,1,1.45,4.51,17.26,17.26,0,0,1,.21,2.4v2.41c0,12.91,0,26.77,0,41.46,0,29.38,0,62.06,0,97v.26H169.12a55.94,55.94,0,0,0-9,.43,34.93,34.93,0,0,0-27.64,22.07,27.25,27.25,0,0,0-1.09,3.27,28,28,0,0,0-.77,3.35l-.26,1.7-.12.85-.05.85-.08,1.71,0,.86v.1c.22-.22-.31.34-.27.28H63.05V386c0-15.07,0-29.6,0-43.48q0-10.41,0-20.33v-9.78c0-1.61,0-3.2,0-4.79a46.38,46.38,0,0,1,.34-4.73,47.45,47.45,0,0,1,5.66-17.22q4.13-7.77,8-15L91.23,244.1l11.51-21.57q1.26-2.35,2.42-4.55c.4-.72.75-1.45,1.17-2.13a21.14,21.14,0,0,1,1.35-1.92,28.38,28.38,0,0,1,6.06-5.63,30.55,30.55,0,0,1,10.37-4.51,26.51,26.51,0,0,1,3.87-.63l-1,.15c-.65.1-1.61.27-2.87.56a30.68,30.68,0,0,0-10.3,4.56,28.16,28.16,0,0,0-6,5.63,17.81,17.81,0,0,0-1.33,1.9c-.41.66-.76,1.4-1.16,2.13l-2.41,4.56L91.5,244.24c-4.28,8.06-9,16.95-14.1,26.59l-8,15a46.9,46.9,0,0,0-5.59,17.09,45.59,45.59,0,0,0-.33,4.69c0,1.57,0,3.18,0,4.78v9.78q0,9.91,0,20.33c0,13.88,0,28.41,0,43.48l-.25-.24h66.53c.07-.05-.48.48-.25.24v-.11l0-.86.09-1.74,0-.86.13-.86.26-1.73a28.36,28.36,0,0,1,.78-3.4,27.51,27.51,0,0,1,1.11-3.32,35.48,35.48,0,0,1,28.05-22.4,57.2,57.2,0,0,1,9-.43h52.43l-.26.25c0-34.9,0-67.58,0-97,0-14.69,0-28.55,0-41.46a28.63,28.63,0,0,0-.2-4.75,14.31,14.31,0,0,0-1.41-4.41,15,15,0,0,0-6.15-6.4,16,16,0,0,0-4.06-1.55,15.28,15.28,0,0,0-4.25-.29c-2.83.24-5.6.6-8.29.89l-50.69,5.61-13.61,1.49-3.51.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.83,313.68s.28,0,.78-.12a5.5,5.5,0,0,0,2.06-.82,5.21,5.21,0,0,0,2.09-2.72,5.78,5.78,0,0,0,.27-2.16,5.25,5.25,0,0,0-.61-2.32,5.18,5.18,0,0,0-4.5-2.75l-6.6,0-15.12,0a5.13,5.13,0,0,0-5.09,4.55,5.71,5.71,0,0,0,.63,3.45,5.13,5.13,0,0,0,2.5,2.22,7.8,7.8,0,0,0,3.26.4h3.2l5.75,0,8.33.08,2.27,0a4,4,0,0,1,.78.06,6.85,6.85,0,0,1-.78.05l-2.27,0-8.33.08-5.75,0h-3.2c-.56,0-1.1,0-1.69,0a6,6,0,0,1-1.75-.4,5.64,5.64,0,0,1-2.74-2.42,6.21,6.21,0,0,1-.7-3.75,5.63,5.63,0,0,1,5.58-5l15.12,0,6.6,0a5.55,5.55,0,0,1,5.44,5.49,6.11,6.11,0,0,1-.33,2.25,5.44,5.44,0,0,1-2.25,2.8,5.19,5.19,0,0,1-2.15.75A3.47,3.47,0,0,1,205.83,313.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,301.12a73.2,73.2,0,0,1-8.57.25,73.3,73.3,0,0,1-8.58-.25,71.89,71.89,0,0,1,8.58-.26A71.79,71.79,0,0,1,204,301.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.67,425.68l-8-.58c2.09-28.65,5.15-45.79,9.36-52.4,8.08-12.7,16.11-15,25-16.51,8.28-1.41,16.63-1.08,24.71-.75l2,.08c16.68.65,51.62.07,52,.07l.13,8c-.35,0-35.51.59-52.41-.07l-2-.08c-7.67-.3-15.59-.63-23.05.65-7.95,1.35-13.24,2.9-19.62,12.92C143.86,380,140.24,390.39,137.67,425.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 99.32,
    width: 393.98,
    height: 262.32,
    style: {
      fill: "#807C7B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.26,356.45c0-1.69-.08-97.9-.21-251.2l.21.2-385,.06h0l.26-.26c0,89.29,0,174.28,0,251.2l-.24-.24,385,.24-385,.24H251v-.24c0-76.92,0-161.91,0-251.2V105h.29l385,.05h.21v.21C636.34,258.55,636.26,354.77,636.26,356.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "302.86 240.04 306.58 315.07 598.77 254.29 593.6 176.08 302.86 240.04"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M325,292l2-7a20.33,20.33,0,0,0,12.41,1.18c4.47-1,7-3.12,6.41-5.69-1.21-5.63-18,1.13-20.43-10.09-1.55-7.24,3.78-13.28,13.54-15.37,4.73-1,9.33-.9,12.82.4L350,262.3a17.55,17.55,0,0,0-10.14-.67c-4.73,1-7.11,3.42-6.57,5.94,1.2,5.79,18.05-1,20.38,9.83,1.56,7.3-3.87,13.36-13.68,15.46C334.27,294.1,328.47,293.55,325,292Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.48,244.35l.51,36.72-8.15,1.75-.21-14.95-15.95,3.42.22,15L359.69,288l-.51-36.73,8.2-1.76.2,14.43,15.95-3.42-.2-14.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.82,242.56,408,240.8l.51,36.72-8.2,1.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.7,244c1.92,8.95-3.47,16-14,18.21l-7.85,1.68L425,274l-8.2,1.76L416.32,239,430.56,236C439.36,234.07,445.22,237.08,446.7,244Zm-8.1,2.47c-.73-3.42-3.49-4.51-7.62-3.62l-6.39,1.37.16,12.75,6.89-1.48C437,254.31,439.6,251.12,438.6,246.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,236.17c1.92,9-3.47,16-14,18.21l-7.84,1.69.17,10.11-8.2,1.76-.52-36.72,14.24-3.06C475.68,226.27,481.54,229.28,483,236.17Zm-8.1,2.48c-.73-3.43-3.5-4.52-7.62-3.63l-6.39,1.37.16,12.76,6.89-1.48C473.34,246.51,475.92,243.32,474.92,238.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,223.42l8.2-1.76.52,36.73-8.2,1.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.76,213l.52,36.72-6.7,1.44L513.73,231.9l.3,23-8,1.73-.52-36.73,6.74-1.45,17.87,19.27-.36-23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.19,223.83l7.45-1.6.19,15.11a22.91,22.91,0,0,1-12.56,7.17c-10.67,2.29-18.74-2.45-20.69-11.55-2.58-12,4.27-23,17.6-25.88,6.74-1.45,12.13-.35,16,3l-4.82,6c-3-2.31-6.12-2.79-10-1.95-8.25,1.77-12.26,8.84-10.6,16.59,1.13,5.28,5.42,8.1,12.11,6.66a13.88,13.88,0,0,0,5.57-2.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.11 170.62 361.11 236.15 527.63 199.53 527.57 134.76 361.11 170.62",
    style: {
      fill: "#807C7B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "361.11 170.62 361.11 236.15 527.63 199.53 527.57 134.76 361.11 170.62"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M385.53,186.92l.37,14.42,18.22-4.14.07,3.36L386,204.7l.42,15.58-3.66.83-.95-36.72,24.08-5.47.08,3.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.26,197.29l9.29,10.23-4,.91-8.86-9.75c-.54.18-1.19.32-1.8.46l-10,2.27.32,11.64-3.71.84-.95-36.71,12.64-2.88c8-1.81,13.38.82,14.8,7.09C442.63,188.61,439.68,194.19,433.26,197.29Zm4.1-14.71c-1.05-4.61-4.87-6.33-10.69-5l-9.33,2.12.42,18.37,9.49-2.15C435.17,194.11,438.93,189.51,437.36,182.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.56,171.46l.33,13.07,18.21-4.14.12,3.3L454,187.82l.36,13.64,21.12-4.8.08,3.36-24.79,5.63-.95-36.71,24.08-5.48.08,3.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.12,163.84l.33,13.06,18.22-4.14.11,3.3-18.21,4.14.35,13.64,21.13-4.8.07,3.36L484.34,198l-1-36.72,24.09-5.47.08,3.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "546.72 170.62 605.69 156.81 603.36 150.53 546.72 170.62",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.67 214.75 323.67 205.15 322.05 200.79 282.67 214.75",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.04 313.54 482.01 299.72 479.69 293.45 423.04 313.54",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.21,139.21c0,.14-31.48,7.67-70.37,16.81s-70.46,16.45-70.5,16.31,31.47-7.67,70.38-16.81S501.18,139.07,501.21,139.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.67,229.57c0,.14-13.5,3-30.22,6.36s-30.29,6-30.32,5.86,13.5-3,30.22-6.37S360.64,229.43,360.67,229.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.2,223.64a1.84,1.84,0,0,1-.06-.53c0-.41,0-.91-.05-1.51,0-1.39,0-3.27-.08-5.56,0-4.77-.08-11.22-.12-18.35s-.14-13.59-.19-18.35c0-2.29-.06-4.17-.08-5.56v-1.52a1.76,1.76,0,0,1,0-.52,2,2,0,0,1,.07.52c0,.41.06.9.1,1.51.08,1.31.16,3.21.24,5.56.17,4.69.3,11.18.35,18.35s0,13.66,0,18.35c0,2.3-.06,4.18-.08,5.57,0,.6,0,1.1-.05,1.51A3.13,3.13,0,0,1,361.2,223.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,223.54s-.12.12-.37.31l-1.1.79c-1,.69-2.37,1.65-4.11,2.84-3.49,2.36-8.35,5.58-13.77,9.05s-10.37,6.54-14,8.73c-1.8,1.09-3.27,2-4.29,2.56l-1.18.66a2,2,0,0,1-.43.21s.12-.12.37-.29l1.13-.76,4.21-2.69,13.89-8.86,13.84-8.92,4.21-2.69,1.16-.72A2.28,2.28,0,0,1,191,223.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.91,228.06s-.12.12-.37.31l-1.1.79c-1,.68-2.37,1.65-4.12,2.83-3.49,2.37-8.35,5.58-13.76,9s-10.37,6.55-14,8.74c-1.8,1.09-3.27,2-4.29,2.55l-1.18.67a1.54,1.54,0,0,1-.43.2,2.1,2.1,0,0,1,.37-.29l1.13-.75,4.2-2.7,13.9-8.85,13.84-8.92,4.21-2.7,1.15-.71A1.83,1.83,0,0,1,173.91,228.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.72,257.17a2.72,2.72,0,0,1-.31-.88c-.16-.57-.38-1.41-.63-2.45a35.68,35.68,0,0,1-1-8.3,18,18,0,0,1,1.9-8.14,11.78,11.78,0,0,1,1.42-2.12,3,3,0,0,1,.66-.65A32.25,32.25,0,0,0,90,237.57a19.15,19.15,0,0,0-1.71,8,42.74,42.74,0,0,0,.89,8.22A27.47,27.47,0,0,1,89.72,257.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,328.07A5.29,5.29,0,0,1,49,327c0-.72,0-1.76.06-3,.08-2.57.27-6.12.58-10s.68-7.44,1-10c.16-1.28.3-2.31.41-3a5.23,5.23,0,0,1,.23-1.09,4.18,4.18,0,0,1,0,1.12l-.26,3c-.22,2.68-.52,6.15-.85,10s-.53,7.31-.72,10c-.09,1.2-.17,2.21-.23,3A4.34,4.34,0,0,1,49,328.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.59,347.48c0,.11-1.93.38-4.92,1.35a38.89,38.89,0,0,0-5.11,2.07,38.49,38.49,0,0,0-10.82,8,38.69,38.69,0,0,0-3.51,4.25c-1.81,2.57-2.66,4.34-2.75,4.29a7.71,7.71,0,0,1,.56-1.26,13,13,0,0,1,.76-1.42c.32-.54.67-1.17,1.13-1.82a35,35,0,0,1,3.46-4.37A40.53,40.53,0,0,1,142.5,354a38.76,38.76,0,0,1,5.86-3.51,34.64,34.64,0,0,1,5.2-2c.75-.25,1.46-.39,2.07-.54a15.73,15.73,0,0,1,1.59-.3A7.2,7.2,0,0,1,158.59,347.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.07,287.11a2.43,2.43,0,0,1,0-.43q0-.46,0-1.26c0-1.14,0-2.77-.07-4.85-.06-4.24-.14-10.33-.25-17.84-.27-15.09-.64-35.88-1.05-58.85s-.76-43.8-.9-58.86c-.07-7.53-.09-13.63-.08-17.84,0-2.09,0-3.72,0-4.85l0-1.26c0-.29,0-.43,0-.43a2.3,2.3,0,0,1,0,.43q0,.45,0,1.26c0,1.13,0,2.76.07,4.85.06,4.24.14,10.32.25,17.83.27,15.09.64,35.88,1.05,58.86s.77,43.79.9,58.85c.07,7.54.1,13.63.09,17.84,0,2.09,0,3.72,0,4.86,0,.53,0,.95,0,1.26A3.62,3.62,0,0,1,257.07,287.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544.45,
    cy: 414.17,
    r: 47.94,
    transform: "translate(-16.08 22.04) rotate(-2.29)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.53,413.35s0,.09,0,.13a47.93,47.93,0,1,0,95.86,1.38v-.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.8,413.68a33.65,33.65,0,1,0,34.14-33.16A33.66,33.66,0,0,0,510.8,413.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.94,380.52a33.65,33.65,0,0,0-34.14,33.16l67.3,1A33.65,33.65,0,0,0,544.94,380.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524,413.87a20.5,20.5,0,1,0,20.79-20.2A20.5,20.5,0,0,0,524,413.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.44,427.3s-7.3-68,63.16-68c65,0,63.56,58.48,62.94,67.53H597.35s5.19-57.64-52.75-57.64S491.7,428,491.7,428,487.42,427.79,481.44,427.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.18,366.34a2.32,2.32,0,0,1-.55.2c-.37.13-.92.26-1.6.5a48.72,48.72,0,0,0-5.73,2.23,45.84,45.84,0,0,0-25.22,30,49,49,0,0,0-1.21,6c-.11.72-.15,1.28-.21,1.66a3.52,3.52,0,0,1-.1.58,2.34,2.34,0,0,1,0-.58c0-.39,0-1,.12-1.68a40.78,40.78,0,0,1,1.06-6.1,44.79,44.79,0,0,1,25.42-30.27,42.1,42.1,0,0,1,5.82-2.1c.7-.2,1.26-.31,1.63-.4A2.56,2.56,0,0,1,519.18,366.34Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.25,435.54l8.52,12.82,3.83,12.08a1.57,1.57,0,0,0,2.08,1h0a1.54,1.54,0,0,0,1-1.08c.78-3.16,3.59-14.8,2.92-15.71s-8.1-14.11-8.1-14.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.68,461.43,710,443.77l.35.55a2.36,2.36,0,0,1,.35,1.6c-.21,1.49-.89,5.6-3,14.4a1.56,1.56,0,0,1-1,1.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704.67,441.26a1,1,0,0,0,.44,1.19.92.92,0,0,0,1.19-.43,1,1,0,0,0-.48-1.26.94.94,0,0,0-1.18.59",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M706.05,453.87a4.56,4.56,0,0,0-1.78-.29,4.79,4.79,0,0,0-1.68.66s.07-.23.35-.47a2.48,2.48,0,0,1,1.3-.53,2.4,2.4,0,0,1,1.38.25C705.94,453.66,706.08,453.84,706.05,453.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.23,456.2a10.43,10.43,0,0,0-1.51.17,10.11,10.11,0,0,0-1.37.64c-.08-.05.37-.72,1.28-1A1.74,1.74,0,0,1,706.23,456.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.37,450.54a15.28,15.28,0,0,0-2.35.11,14.6,14.6,0,0,0-2.21.77,3.44,3.44,0,0,1,2.15-1.1A3.57,3.57,0,0,1,706.37,450.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.1,446.43c0,.1-.9.25-1.85.81s-1.56,1.25-1.64,1.19a3.09,3.09,0,0,1,1.47-1.48A3,3,0,0,1,704.1,446.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.69,442.6a7.88,7.88,0,0,0-2,.8,8.1,8.1,0,0,0-1.45,1.52s0-.26.19-.63a3.46,3.46,0,0,1,2.55-1.74C701.44,442.51,701.69,442.56,701.69,442.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.3,442.66a1.55,1.55,0,0,1-.32-.48,3.9,3.9,0,0,1-.43-1.54,1.82,1.82,0,0,1,.19-1.13.64.64,0,0,1,.68-.27,1.07,1.07,0,0,1,.58.46,2.23,2.23,0,0,1-.55,2.79,2.59,2.59,0,0,1-2.87.21.85.85,0,0,1-.43-.6.61.61,0,0,1,.37-.63,2.2,2.2,0,0,1,1.14-.1,4.59,4.59,0,0,1,1.53.45,1.55,1.55,0,0,1,.48.32,7.34,7.34,0,0,0-2-.53,2.07,2.07,0,0,0-1,.11.33.33,0,0,0-.21.34.62.62,0,0,0,.31.38,2.32,2.32,0,0,0,2.49-.21,2,2,0,0,0,.5-2.36.74.74,0,0,0-.39-.34.35.35,0,0,0-.38.14,1.57,1.57,0,0,0-.18,1A6.38,6.38,0,0,0,699.3,442.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.15,442.87l-1,12.87s12.77,4.37,12.82,6.77l-25-.06.7-20.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M675.48,454.35a1,1,0,0,0-.75,1.13,1,1,0,0,0,1.12.76,1.08,1.08,0,0,0,.79-1.21,1,1,0,0,0-1.25-.66",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671,462.45l.07-2,24.17.9a1.75,1.75,0,0,1,.92,1.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M683.58,455.63c0,.12-.62.15-1.24.52s-1,.87-1.06.82.1-.76.85-1.19S683.61,455.52,683.58,455.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.16,456.82c0,.12-.51.3-.95.8s-.57,1-.7,1-.17-.7.39-1.31S686.16,456.7,686.16,456.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.53,460c-.11,0-.26-.6.08-1.26s.92-.9,1-.79-.32.45-.59,1S687.65,460,687.53,460Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.48,452.67c-.06.11-.61-.08-1.3-.06s-1.24.21-1.3.11.47-.53,1.29-.54S683.54,452.58,683.48,452.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "683.95 445.42 683.78 447.71 671.49 447.11 671.56 445.04 683.95 445.42"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M683.63,450.07a2.34,2.34,0,0,1-1.25-.05,6,6,0,0,1-1.3-.46,5.09,5.09,0,0,1-.7-.41,1.45,1.45,0,0,1-.37-.31.54.54,0,0,1,0-.65.69.69,0,0,1,.55-.26,1.9,1.9,0,0,1,.46.08,4.94,4.94,0,0,1,.77.3,4.5,4.5,0,0,1,1.13.81c.56.56.74,1,.69,1s-.32-.35-.89-.82a5.33,5.33,0,0,0-1.1-.67,3.71,3.71,0,0,0-.71-.25c-.26-.08-.48-.09-.56,0s0,.06,0,.14a1,1,0,0,0,.26.23,6.74,6.74,0,0,0,.65.4,7.19,7.19,0,0,0,1.19.52A9.44,9.44,0,0,1,683.63,450.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.46,450.24a2,2,0,0,1-.28-1.22,4.18,4.18,0,0,1,.57-2.11,1,1,0,0,1,.83-.61.62.62,0,0,1,.51.37,2.42,2.42,0,0,1,.11.47,2.86,2.86,0,0,1-.62,2.12c-.52.62-1,.75-1,.71s.4-.28.8-.89a3.06,3.06,0,0,0,.44-1.16,2.55,2.55,0,0,0,0-.73c0-.27-.11-.48-.22-.46s-.34.18-.45.39a4.23,4.23,0,0,0-.34.67,4.5,4.5,0,0,0-.29,1.24C683.42,449.76,683.53,450.22,683.46,450.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.29,337s4.59,9.41,5.79,16.12c.34,1.9-13.14,98.36-13.14,98.36l-15.94-.6,7.47-89.76-2.66-18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.57,342.83a143.21,143.21,0,0,0,1,19.5c1.18,9.46,3.88,20.23,4.76,26.25,1.94,13.32,5.76,15.84,5.76,15.84l30.58,39.13,12-10.79-27-43.13s-7.18-47.86-6.93-46.57S654.57,342.83,654.57,342.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.73,405a3.44,3.44,0,0,0,.29.41l.87,1.12,3.21,4.14c2.71,3.53,6.4,8.37,10.49,13.72s7.81,10.21,10.57,13.67c1.37,1.73,2.5,3.12,3.3,4.07l.92,1.08a3,3,0,0,0,.34.37,2.38,2.38,0,0,0-.29-.41l-.87-1.13-3.21-4.13-10.49-13.73c-4.08-5.37-7.81-10.21-10.57-13.66-1.37-1.74-2.5-3.12-3.29-4.07l-.93-1.09A2.39,2.39,0,0,0,666.73,405Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.32,350.16a3.33,3.33,0,0,1-.43,1.53,9.8,9.8,0,0,1-5.46,5.12,3.7,3.7,0,0,1-1.55.33,17.2,17.2,0,0,0,4.43-2.73A16.9,16.9,0,0,0,663.32,350.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.32,344.7a4.17,4.17,0,0,1-4.48-.66c.07-.13,1,.3,2.22.47S696.29,344.56,696.32,344.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.11,358a4.91,4.91,0,0,1,.11.64c.06.46.13,1.07.23,1.84.18,1.65.44,4,.77,6.86.62,5.88,1.47,14,2.45,23.34l0-.11,4.43,7.08,15.39,24.77c1.93,3.15,3.5,5.71,4.61,7.54L708.3,432a4.25,4.25,0,0,1,.39.74,5.89,5.89,0,0,1-.48-.69l-1.32-2-4.75-7.45c-4-6.35-9.47-15.06-15.52-24.68l-4.42-7.09,0,0v-.06c-.9-9.31-1.7-17.47-2.27-23.36l-.62-6.88c-.06-.77-.11-1.38-.14-1.85A2.82,2.82,0,0,1,679.11,358Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.46,273.94,684,277l.72,20.23S689.88,321,691,324a61.26,61.26,0,0,1,2.91,11.08s-1.84,13.42-15.25,15-25.89-6.12-25.89-6.12-4.47-20-8.57-37.94c-3.9-17.07-.73-27.25-.73-27.25l14.69-5.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.89,
    y: 285.72,
    width: 8.83,
    height: 2.27,
    transform: "translate(-29.56 83.45) rotate(-6.9)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.66,261a2,2,0,0,0-2.13-1.66,1.67,1.67,0,0,0-.21-2.8,3.44,3.44,0,0,0-.71-4.56l-10.07,13.89a7.32,7.32,0,0,0,5.55,1.52,14.85,14.85,0,0,0,5.55-2,2.28,2.28,0,0,0,1.1-1c.19-.47-.08-1.15-.6-1.16A2,2,0,0,0,683.66,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.65,253.41a.95.95,0,0,0-1,1.47,1.68,1.68,0,0,0-1.74,2.39,3.25,3.25,0,0,0-2,.55,1.89,1.89,0,0,0-.8,1.87,1.35,1.35,0,0,0,1.6,1,1.86,1.86,0,0,0,.1,2,1.2,1.2,0,0,0,1.82.05,1.44,1.44,0,0,0,1.79,2.15,1.57,1.57,0,0,0,2.53,1.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.27,250.75l-.44,24.59a7.65,7.65,0,0,0,7,7.75h0a7.65,7.65,0,0,0,8.32-7.44c0-2.34.08-4.26.08-4.26s6-.4,6.59-6.3c.35-3.42.44-11.22.46-17.21a7.78,7.78,0,0,0-7.1-7.78l-3.57-.31A11,11,0,0,0,659.27,250.75Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.21,271.39a14.32,14.32,0,0,1-7.5-3s1.52,4.47,7.47,4.46Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.61,253.89c-.11.1-.71-.43-1.62-.51s-1.61.32-1.7.2.08-.25.39-.43a2.29,2.29,0,0,1,1.37-.3,2.24,2.24,0,0,1,1.28.55C679.59,253.63,679.67,253.84,679.61,253.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670,254.28a.85.85,0,0,1-.89.78.81.81,0,0,1-.81-.83.85.85,0,0,1,.89-.78A.81.81,0,0,1,670,254.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.8,255.08a.85.85,0,0,1-.89.78.82.82,0,0,1-.8-.84.84.84,0,0,1,.89-.78A.8.8,0,0,1,678.8,255.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.77,253.11c-.11.1-.71-.43-1.62-.51s-1.62.32-1.71.2.08-.25.39-.43a2.32,2.32,0,0,1,2.66.24C670.75,252.85,670.83,253.06,670.77,253.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.47,260.14A6.31,6.31,0,0,1,675,260c.24,0,.46,0,.51-.18a1.15,1.15,0,0,0-.09-.7c-.17-.59-.35-1.19-.53-1.83a29.64,29.64,0,0,1-1.13-4.76,31.05,31.05,0,0,1,1.51,4.65c.17.65.34,1.26.5,1.84a1.37,1.37,0,0,1,0,.92.6.6,0,0,1-.41.31,1.91,1.91,0,0,1-.4,0A6,6,0,0,1,673.47,260.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.74,260.53c.15,0,.07,1,.85,1.77s1.84.76,1.84.89-.26.18-.7.15a2.48,2.48,0,0,1-1.54-.7,2.13,2.13,0,0,1-.65-1.47C670.54,260.75,670.68,260.52,670.74,260.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.27,250.17c-.12.24-1,0-2.09.08s-2,.25-2.09,0,.12-.33.49-.54a3.48,3.48,0,0,1,1.58-.4,3.56,3.56,0,0,1,1.6.33C671.13,249.85,671.31,250.06,671.27,250.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.72,251.27c-.18.2-.79-.07-1.54-.15s-1.4,0-1.53-.21.06-.31.36-.48a2.24,2.24,0,0,1,2.47.29C679.73,251,679.8,251.18,679.72,251.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.87,255.36c-.1-.05-4-1.56-4.19,2.5s3.89,3.45,3.91,3.33S660.87,255.36,660.87,255.36Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.44,259.58s-.08.05-.2.1a.75.75,0,0,1-.53,0,1.75,1.75,0,0,1-.72-1.61,2.51,2.51,0,0,1,.25-1,.87.87,0,0,1,.57-.51.35.35,0,0,1,.4.22c0,.12,0,.2,0,.2s.09-.06.07-.23a.44.44,0,0,0-.15-.26.53.53,0,0,0-.38-.13,1,1,0,0,0-.77.59,2.36,2.36,0,0,0-.31,1.12,1.84,1.84,0,0,0,.93,1.81.79.79,0,0,0,.65-.07C659.42,259.68,659.45,259.59,659.44,259.58Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.63,255a2.13,2.13,0,0,1,1.86,1.17c.21.6.21,1.26.42,1.86s.76,1.18,1.39,1.08a1.24,1.24,0,0,0,.93-.84,3.4,3.4,0,0,0,.12-1.31c-.07-1.91-.3-3.82-.21-5.72a9.87,9.87,0,0,1,1.68-5.4,5.34,5.34,0,0,1,5-2.24c1.25.21,2.34,1,3.57,1.26a5,5,0,0,0,4.23-1c.15-.12.82-.48.82-.48a2.4,2.4,0,0,0-.32-1.29c-2.27-2.51-6.68-3.55-10-3a11.84,11.84,0,0,0-8.29,5.51c-1.68,2.95-1.64,7.25-1.14,10.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682,246.87a3.85,3.85,0,0,1-3.39,1.8,10.71,10.71,0,0,1-3.9-.93,31.76,31.76,0,0,0-6-1.43c-.2,0-.44,0-.53-.21s.13-.49.35-.64c1.89-1.22,6.22-1.69,8.47-1.59a6.61,6.61,0,0,1,5.56,3.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.41,247a7.24,7.24,0,0,0-4.74-2.68,19.57,19.57,0,0,0-18.24,9.14,25.27,25.27,0,0,1-.54-5.24c.1-1.21,1.46-8.31,9-9.91C666.92,238.29,678.4,235,681.41,247Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.22,251.93a29.19,29.19,0,0,1,9.81-7.86,56.87,56.87,0,0,1,14-4.31,8.93,8.93,0,0,1,3.78-.07,3.39,3.39,0,0,1,2.57,2.52c.25,1.56-2.68,3.69-4,4.5a41.19,41.19,0,0,1-4.09,1.95s.29-2.83-4.21-3.82C670.93,243.49,659.22,251.93,659.22,251.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.6,239.89a12,12,0,0,0-1.29-.2,17.11,17.11,0,0,0-3.57.24,54.26,54.26,0,0,0-11.39,3.23,31.51,31.51,0,0,0-10,6.2,14.52,14.52,0,0,0-2.28,2.74c-.44.72-.61,1.16-.65,1.14s0-.12.08-.33a6.36,6.36,0,0,1,.4-.91,12.43,12.43,0,0,1,2.2-2.9,29.44,29.44,0,0,1,10.06-6.42,48.55,48.55,0,0,1,11.53-3.12,15.15,15.15,0,0,1,3.64-.07,3.23,3.23,0,0,1,1,.24C687.51,239.82,687.61,239.87,687.6,239.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673,241.46a14.74,14.74,0,0,1,4.62-1.13,5.84,5.84,0,0,0-1.15-.84,11.73,11.73,0,0,0-3.6.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.09,249a1.79,1.79,0,0,0-1.33-2.83,1.64,1.64,0,0,0,.86-2.25,2.07,2.07,0,0,0-2.36-.92,2.89,2.89,0,0,0-1.85,1.88,1.95,1.95,0,0,0-3.32.14,1.05,1.05,0,0,0-1.27-.66,3.65,3.65,0,0,0-1.36.81,2.41,2.41,0,0,1-1.43.65l-.35.15a2.22,2.22,0,0,0,2.82.84,1.57,1.57,0,0,0,2.89.87,1.56,1.56,0,0,0,2.47.86,2,2,0,0,0,3.1.86,3.37,3.37,0,0,1,.38,2.75,1.8,1.8,0,0,0,.75-3.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.18,248a26.13,26.13,0,0,0-4,2.21,8.7,8.7,0,0,0-2.95,3.45l2,1.91c.55.18,1,.37,1.42,0a1.73,1.73,0,0,0,.58-1.54A1.48,1.48,0,0,0,663.9,252a1.15,1.15,0,0,0,.84-.8,1.18,1.18,0,0,0-.29-1.12,1.16,1.16,0,0,0,.73-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684,277s5.91,3.55,7.69,6.71,11.24,26.22,10.85,30-9.27,6.11-9.27,6.11l-9.27-12,4.24-2.53L684,297.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.29,319.79s-21.48,4.3-29.28-5l2.26-7.85s14.19,3.36,18.63,1.92Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.51,300.71c.08.16-2.52,1.25-5.23,3.32s-4.42,4.31-4.56,4.2a5.34,5.34,0,0,1,1-1.52,19.79,19.79,0,0,1,3.19-3.09,20.41,20.41,0,0,1,3.81-2.29A5.65,5.65,0,0,1,695.51,300.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.62,305a22.14,22.14,0,0,1-1.93-3.83,28.22,28.22,0,0,1-1.76-3.91,13,13,0,0,1,2.23,3.69A15.39,15.39,0,0,1,688.62,305Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.72,295.29a16.27,16.27,0,0,0-.52-3.34,17.33,17.33,0,0,0-.87-3.28,33.79,33.79,0,0,0,1.39,6.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.16,280c.41.43,6.31,4.34,8.28,11s4.14,13.61,4.14,13.61l7.69,1-4.34,17.74a20.72,20.72,0,0,1-14.39-9.46A95.73,95.73,0,0,1,639.26,295S639.91,273.46,646.16,280Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.63,305.26s-3.26-7.3-3.7-7.4-6.73-2.31-6.73-2.31a2.27,2.27,0,0,0,0,1.59l-2.27.29s.34,1.39,1.11,1.58l-.82.73a4.61,4.61,0,0,0,1.54,1.3,1.68,1.68,0,0,0,1.49,0s-.28.52,1,1.34,3.51,2,3.51,2Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.77,304.42h0s-2.23-1.22-3.51-2c-1.11-.7-1.08-1.18-1-1.32a1.77,1.77,0,0,1-1.46,0,4.79,4.79,0,0,1-1.55-1.31v0L652,299c-.75-.22-1.08-1.53-1.09-1.59v0l2.26-.29a2.36,2.36,0,0,1,0-1.58h0c.06,0,6.31,2.22,6.74,2.31s3.57,7.11,3.71,7.41v0Zm-5.56-7.29v0l-2.27.29c0,.16.39,1.38,1.1,1.56h0l-.83.73a4.43,4.43,0,0,0,1.52,1.28,1.69,1.69,0,0,0,1.48,0l0,0,0,.06s-.26.52,1,1.32,3.43,2,3.51,2l4.83.85c-1.14-2.53-3.35-7.29-3.68-7.36s-6.38-2.19-6.72-2.31A2.18,2.18,0,0,0,653.21,297.13Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.4,297.16a27.88,27.88,0,0,0,4.12,1.61c.58.21,1.15.36,1.6.58a2.06,2.06,0,0,1,.94.9c.38.68.52,1.17.58,1.15a3,3,0,0,0-.36-1.27,2.32,2.32,0,0,0-1-1.06,14.33,14.33,0,0,0-1.64-.62A30.64,30.64,0,0,0,653.4,297.16Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.93,299a3.17,3.17,0,0,0,1.14.41c.72.2,1.74.36,2.82.65a7.22,7.22,0,0,1,2.55,1.2c.58.45.83.84.88.81a2.2,2.2,0,0,0-.72-1,6.37,6.37,0,0,0-2.62-1.35c-1.11-.3-2.14-.42-2.86-.55A5.43,5.43,0,0,0,651.93,299Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.7,302.34a2.65,2.65,0,0,0-1.51-1,2.82,2.82,0,0,0-1.82-.17c0,.11.8.16,1.71.49S657.64,302.42,657.7,302.34Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.61,307.5,685,297.72l3.55,7.23s-17.87,17.71-26.24,17.48",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.83,287a6.09,6.09,0,0,0,.26,1.44c.21.87.51,2.07.87,3.39s.7,2.52,1,3.38a5.9,5.9,0,0,0,.5,1.36,6.78,6.78,0,0,0-.26-1.43c-.21-.87-.51-2.07-.87-3.4s-.7-2.51-1-3.36A6.38,6.38,0,0,0,653.83,287Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.67,311.07c.06,0,.23-.89.68-2.28a7.4,7.4,0,0,1,1.16-2.24A4.16,4.16,0,0,1,659,305a9.72,9.72,0,0,1,3.07.35l2.54.51a4,4,0,0,1,.93.24.91.91,0,0,1,.47.48.73.73,0,0,1,0,.58s.27-.16.16-.62a1,1,0,0,0-.51-.61,3.94,3.94,0,0,0-1-.31l-2.53-.58a9.42,9.42,0,0,0-3.19-.38,4.4,4.4,0,0,0-2.71,1.73,7.25,7.25,0,0,0-1.14,2.36,15,15,0,0,0-.39,1.72A2,2,0,0,0,654.67,311.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652,307.17a8.14,8.14,0,0,1,2.09-2.42,12.74,12.74,0,0,1,3-1.3,2.13,2.13,0,0,0-1,.08,5.86,5.86,0,0,0-2.17.94,5.19,5.19,0,0,0-1.59,1.77A1.92,1.92,0,0,0,652,307.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.26,295s0,.13.1.38.21.63.36,1.06c.33,1,.78,2.28,1.34,3.89s1.24,3.61,2.2,5.71,2.09,4.36,3.46,6.65a22.62,22.62,0,0,0,4.83,5.74,20.83,20.83,0,0,0,5.2,3.25,15.36,15.36,0,0,0,4,1.11,11.07,11.07,0,0,0,1.12.11c.26,0,.39,0,.39,0s-.53-.06-1.49-.23a16.62,16.62,0,0,1-3.9-1.21,22.13,22.13,0,0,1-9.83-8.93c-1.36-2.27-2.46-4.56-3.47-6.61s-1.66-4-2.27-5.66-1.08-2.95-1.44-3.86l-.42-1A2.08,2.08,0,0,0,639.26,295Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.82,280.42c0,.1,1.48.64,3.17,1.65s2.9,2.06,3,2a12.1,12.1,0,0,0-6.14-3.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.53,327.54a6.61,6.61,0,0,0,1,.5c.33.16.73.34,1.2.52s1,.42,1.62.61a38.64,38.64,0,0,0,4.32,1.26,45.49,45.49,0,0,0,5.45.86,43.15,43.15,0,0,0,5.52.1,38.93,38.93,0,0,0,4.48-.47c.63-.09,1.2-.22,1.69-.32s.93-.21,1.27-.3a7.81,7.81,0,0,0,1.07-.32,8,8,0,0,0-1.1.19c-.34.07-.77.16-1.27.24s-1.07.2-1.7.27a42.14,42.14,0,0,1-4.46.4,46.77,46.77,0,0,1-5.47-.14,47.5,47.5,0,0,1-5.41-.82,42.83,42.83,0,0,1-4.31-1.18c-.62-.18-1.15-.39-1.63-.56s-.88-.33-1.21-.46A8.27,8.27,0,0,0,659.53,327.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.28,337.61a16.75,16.75,0,0,0,3.93-1,16.56,16.56,0,0,0,3.72-1.58c0-.09-1.72.55-3.83,1.25S675.26,337.52,675.28,337.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M690.08,320.32a37.49,37.49,0,0,1-13.44.2,14.5,14.5,0,0,0-5-.6,16.66,16.66,0,0,0-3.85,1.46,15.05,15.05,0,0,1-14.18-1.47,9.77,9.77,0,0,0,7.34,5.15,21.68,21.68,0,0,0,9.21-.82,23.94,23.94,0,0,1,5.46-1.1c2.36-.06,4.67.71,7,.75a12.62,12.62,0,0,0,7.65-2.31Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M682.4,335.72a12.41,12.41,0,0,1-9.44,6,6.13,6.13,0,0,1-2.49-.2,3.07,3.07,0,0,1-1.88-1.57,8.91,8.91,0,0,1,2.93-1.21l10.77-2.95"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M688.26,305.24a6.79,6.79,0,0,1-.87.89c-.58.56-1.42,1.36-2.41,2.38s-2.17,2.28-3.61,3.53-3.08,2.54-4.81,3.88a48.68,48.68,0,0,1-5.11,3.5,24.47,24.47,0,0,1-4.6,2.13,19.37,19.37,0,0,1-3.32.81,5.28,5.28,0,0,1-1.24.07,38.31,38.31,0,0,0,4.44-1.22,26.94,26.94,0,0,0,4.48-2.2,53.77,53.77,0,0,0,5-3.5c1.73-1.34,3.38-2.61,4.81-3.83s2.63-2.43,3.67-3.43,1.92-1.76,2.54-2.27A5.14,5.14,0,0,1,688.26,305.24Z",
    style: {
      fill: "#eb996e"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.da392ee283c4b602ef70601a45f8271b.svg";
export { ForwardRef as ReactComponent };